import React, { useEffect, useRef } from 'react';
import { createRoot } from '@wordpress/element';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import GLightbox from 'glightbox';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'glightbox/dist/css/glightbox.min.css';
import './index.css';

const App = () => {
    const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
    const [activeIndex, setActiveIndex]   = React.useState(0);
    const mainSwiperRef                   = useRef(null);
    const lightboxRef                     = useRef(null);

    const images = window.wpData?.imagenes ?? [];
    const total  = images.length;

    useEffect(() => {
        if (images.length === 0) return;

        lightboxRef.current = GLightbox({
            elements: images.map(img => ({
                href: img.src,
                type: 'image',
                description: img.alt || '',
            })),
            touchNavigation: true,
            loop:            true,
            autoplayVideos:  false,
        });

        lightboxRef.current.on('slide_changed', ({ current }) => {
            if (current?.index !== undefined && mainSwiperRef.current) {
                const sw = mainSwiperRef.current;
                sw.slideToLoop ? sw.slideToLoop(current.index) : sw.slideTo(current.index);
            }
        });

        return () => { lightboxRef.current?.destroy(); };
    }, [images]);

    const openFullscreen = () => lightboxRef.current?.openAt(activeIndex);

    if (total === 0) return null;

    return (
        <div className="evo-galeria-wrapper">

            {/* Barra superior */}
            <div className="evo-galeria-toolbar">
                <span className="evo-galeria-counter">{activeIndex + 1}/{total}</span>
                <div className="evo-galeria-actions">
                    <button
                        className="evo-galeria-btn"
                        title="Pantalla completa"
                        aria-label="Pantalla completa"
                        onClick={openFullscreen}
                    >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 3h6v2H5v4H3V3zm12 0h6v6h-2V5h-4V3zM3 15h2v4h4v2H3v-6zm16 4h-4v2h6v-6h-2v4z"/>
                        </svg>
                    </button>
                </div>
            </div>

            {/* Slider principal */}
            <Swiper
                modules={[Navigation, Thumbs]}
                navigation
                loop={total > 1}
                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                onSwiper={(sw) => { mainSwiperRef.current = sw; }}
                onSlideChange={(sw) => setActiveIndex(sw.realIndex)}
                className="evo-galeria-main"
            >
                {images.map((img, i) => (
                    <SwiperSlide key={i}>
                        <img
                            src={img.src}
                            alt={img.alt || ''}
                            loading="lazy"
                            onClick={openFullscreen}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Thumbnails */}
            {total > 1 && (
                <Swiper
                    modules={[Thumbs]}
                    onSwiper={setThumbsSwiper}
                    spaceBetween={6}
                    slidesPerView="auto"
                    freeMode
                    watchSlidesProgress
                    slideToClickedSlide
                    className="evo-galeria-thumbs"
                >
                    {images.map((img, i) => (
                        <SwiperSlide key={i}>
                            <img src={img.thumb} alt="" loading="lazy" />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}

        </div>
    );
};

const rootElement = document.getElementById('galeria-react-root');
if (rootElement) {
    createRoot(rootElement).render(<App />);
}
